import { isEmpty } from 'lib';

/**
 * تبدیل فایل های بیس 64 به بلاب برای ارسال در فرم دیتا
 * @param {ورودی به شکل بیس 64} b64Data
 */
export const b64ToBlob = (b64Data) => {
  if (isEmpty(b64Data)) return;

  const block = b64Data.split(';');
  const contentType = block[0].split(':')[1];
  const realData = block[1].split(',')[1];

  const sliceSize = 512;

  const byteCharacters = atob(realData);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};
